﻿<script setup>
    import menudef from '@/menu';
    const menu = ref(menudef);

</script>

<template>
    <div bg-blue-500 h-full text-white>
        <div v-for="mi in menu">
            <q-item :to="mi.Path" active-class="text-accent" v-if="mi.Path" clickable v-ripple py-2 pl-4>
                <q-icon :name="mi.Icon" size="md" />
                <span ml-3 mt-1>{{mi.Name}}</span>
            </q-item>
            <q-expansion-item v-if="mi.Items"
                              expand-separator
                              header-class="text-slate-200"
                              expand-icon-class="text-slate-200">
                <template #header="{e}">
                    <div w-full>
                        <q-icon :name="mi.Icon" size="md" />
                        <span ml-3>{{mi.Name}}</span>
                    </div>
                </template>

                <div bg-blue-400>
                    <q-separator my-1 bg-slate-400 />

                    <template v-for="m in mi.Items">
                        <q-item :to="m.Path" active-class="bg-accent text-primary" dense clickable v-ripple py-1 pl-8 my-0 hover:bg-blue-500>
                            <q-icon :name="m.Icon" size="sm" />
                            <span ml-3>{{m.Name}}</span>
                        </q-item>
                    </template>

                    <q-separator my-1 bg-slate-400 />
                </div>

            </q-expansion-item>
        </div>
    </div>
</template>

<style lang="scss">
    @import '@/variables.scss';

</style>